import type { BrandingThemeVariablesDto } from '@services/license';
import { DEFAULT_THEME, applyThemeToDocument, type ThemeVariables } from '../contexts/ThemeVariablesContext';
import { parseBrandingProfileId } from './shareLink';

export function brandingDtoToTheme(dto?: BrandingThemeVariablesDto | null): ThemeVariables {
  return {
    fonts: {
      body: dto?.fonts?.body ?? DEFAULT_THEME.fonts.body,
      heading: dto?.fonts?.heading ?? DEFAULT_THEME.fonts.heading,
      mono: dto?.fonts?.mono ?? DEFAULT_THEME.fonts.mono,
    },
    light: {
      bg: dto?.light?.bg ?? DEFAULT_THEME.light.bg,
      surface: dto?.light?.surface ?? DEFAULT_THEME.light.surface,
      surfaceMuted: dto?.light?.surfaceMuted ?? DEFAULT_THEME.light.surfaceMuted,
      text: dto?.light?.text ?? DEFAULT_THEME.light.text,
      textMuted: dto?.light?.textMuted ?? DEFAULT_THEME.light.textMuted,
      border: dto?.light?.border ?? DEFAULT_THEME.light.border,
      primary: dto?.light?.primary ?? DEFAULT_THEME.light.primary,
      primaryHover: dto?.light?.primaryHover ?? DEFAULT_THEME.light.primaryHover,
      onPrimary: dto?.light?.onPrimary ?? DEFAULT_THEME.light.onPrimary,
      danger: dto?.light?.danger ?? DEFAULT_THEME.light.danger,
      success: dto?.light?.success ?? DEFAULT_THEME.light.success,
    },
    dark: {
      bg: dto?.dark?.bg ?? DEFAULT_THEME.dark.bg,
      surface: dto?.dark?.surface ?? DEFAULT_THEME.dark.surface,
      surfaceMuted: dto?.dark?.surfaceMuted ?? DEFAULT_THEME.dark.surfaceMuted,
      text: dto?.dark?.text ?? DEFAULT_THEME.dark.text,
      textMuted: dto?.dark?.textMuted ?? DEFAULT_THEME.dark.textMuted,
      border: dto?.dark?.border ?? DEFAULT_THEME.dark.border,
      primary: dto?.dark?.primary ?? DEFAULT_THEME.dark.primary,
      primaryHover: dto?.dark?.primaryHover ?? DEFAULT_THEME.dark.primaryHover,
      onPrimary: dto?.dark?.onPrimary ?? DEFAULT_THEME.dark.onPrimary,
      danger: dto?.dark?.danger ?? DEFAULT_THEME.dark.danger,
      success: dto?.dark?.success ?? DEFAULT_THEME.dark.success,
    },
  };
}

export function applyCachedBrandingTheme(uploadId: string): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const brandingProfileId = parseBrandingProfileId(uploadId);
  if (!brandingProfileId) {
    return false;
  }

  const cacheKey = `branding_profile_${brandingProfileId}`;
  const cached = window.localStorage.getItem(cacheKey);
  if (!cached) {
    return false;
  }

  try {
    const parsed = JSON.parse(cached) as { theme?: BrandingThemeVariablesDto | null };
    if (!parsed?.theme) {
      return false;
    }

    const theme = brandingDtoToTheme(parsed.theme);
    applyThemeToDocument(theme);
    return true;
  } catch {
    window.localStorage.removeItem(cacheKey);
    return false;
  }
}
